import { Box } from "@mui/material";
import type { FC } from "react";

const LinksSubHeader: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "rgba(0, 36, 79, 0.1)",
        display: "grid",
        gap: 2,
      }}
    >
      {/* Buttons Section */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default LinksSubHeader;
